import parse from 'html-react-parser';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Container } from 'styled-bootstrap-grid';
import { useAppState } from '../../hooks/app-state';
import { getFooterHtml } from '../../services/footer.service';
import styled from 'styled-components';

const TextCenterContainer = styled(Container)`
    text-align: center;
`;

export function Footer() {
    const [rawFooter, setRawFooter] = useAppState('rawFooter');

    useEffect(() => {
        if (!rawFooter) {
            getFooterHtml().then((html) => {
                setRawFooter(html);
            });
        }
    }, [rawFooter, setRawFooter]);

    if (!rawFooter) {
        return (
            <TextCenterContainer>
                <Skeleton width={170} height={54} style={{ marginTop: '20px', marginBottom: '10px' }} />
                <Skeleton width={250} height={18} style={{ marginTop: '30px', marginBottom: '16px' }} />
                <Skeleton height={13} style={{ marginTop: '30px', marginBottom: '16px' }} />
            </TextCenterContainer>
        );
    }

    return (
        <>
            {parse(rawFooter)}
        </>
    );
}